// extracted by mini-css-extract-plugin
export var aggregationCell = "_2f-n";
export var aggregationRow = "_2f-m";
export var borderlessSpinnerContainer = "_2f-3";
export var cardLayout = "_2f-6";
export var cardLayoutNoFooter = "_2f-9";
export var cardLayoutPageControl = "_2f-8";
export var closeIcon = "_2f-f";
export var columnHeaderSurface = "_2f-b";
export var columnHeaderSurfaceDragOverlay = "_2f-v";
export var columnHeaderSurfaceResizing = "_2f-s";
export var contextMenuAnchor = "_2f-1";
export var draggableColumnHeader = "_2f-t";
export var draggableColumnHeaderOverlay = "_2f-u";
export var expandIcon = "_2f-g";
export var expanded = "_2f-h";
export var filterDropdown = "_2f-i";
export var filterDropdownDivider = "_2f-d";
export var filterDropdownHeader = "_2f-l";
export var filterDropdownItem = "_2f-k";
export var filterDropdownModal = "_2f-j _2f-i";
export var filterItem = "_2f-c";
export var normalCellWithAdjustableBorder = "_2f-e";
export var pinButtonContainer = "_2f-o";
export var pinIcon = "_2f-p";
export var pinIconActive = "_2f-q";
export var spinner = "_2f-0";
export var spinnerContainer = "_2f-2";
export var tableContainer = "_2f-4";
export var tableContentDraggingColumns = "_2f-a";
export var tableContentInner = "_2f-7";
export var tableContentWrapper = "_2f-5";
export var viewButtonContainer = "_2f-r";